import { reformatContentfulLocaleToLocale } from 'lib/utils/helpers';

// Site locale -> Reviews.io language code where they differ (uk would mean Ukrainian, se Northern Sami)
const REVIEWS_IO_LANG = { uk: 'en', se: 'sv', 'fr-fr': 'fr' };

export default async ({ skuArr, locale }) => {
  if (!skuArr?.length) return [];

  const siteLocale = reformatContentfulLocaleToLocale(locale);
  const params = {
    store: 'keune.com',
    lang: REVIEWS_IO_LANG[siteLocale] || siteLocale,
    sku: skuArr.join(';'),
  };

  try {
    const url = `https://api.reviews.io/product/rating-batch?${new URLSearchParams(params)}`;

    const request = await fetch(url);

    if (request.ok) {
      const res = await request.json();
      return res;
    }
    return [];
  } catch (e) {
    console.log(e);
    return [];
  }
};
